import axios from "axios";
import { clearStoredSession, getToken } from "../../utils/session";

const baseDomain = process.env.VUE_APP_BASE_URL;
const baseURL = `${baseDomain}`; // Incase of /api/v1;
// ALL DEFAULT CONFIGURATION HERE

const HttpClient = axios.create({
  baseURL,
});

// The token has to be read per request, not once at import time: this module is created when the
// app boots, which for a fresh visitor is before they have logged in, and logging in does not
// reload the page. Reading it here also means a revoked session stops sending a stale token.
HttpClient.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

HttpClient.interceptors.response.use(
  (response) => {
    try {
      if (response.data.success == false)
        throw new Error(
          `Error: ${response.data.errorMessage}, Errors: ${response.data.errorMessages}`
        );
      else return response;
    } catch (e) {
      //Debug
      console.error(e.message);
      return response;
    }
  },
  (error) => {
    // 401 now means more than "expired": an administrator can revoke this session from My Staffs,
    // and the API rejects the token from that moment on. Either way the stored token is worthless.
    // A hard navigation (rather than router.push) is deliberate - it avoids importing the router
    // into this module, and it throws away every Vuex module still holding the old user's data.
    if (error && error.response && error.response.status === 401) {
      clearStoredSession();
      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    }
    //Debug
    console.log(`Error: ${error}`);
    return Promise.resolve({ error });
  }
);
export default HttpClient;
